import { useState } from "react";
import { apiRest } from "../../../../../hooks/useRest";
import CustomAlerts from "../../../../../alerts/CustomAlerts";

const ModalMetodoPago = ({
  setModal,
  select,
  setSelect,
  setMetodosPago,
  fetch,
}) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    id: select ? select.id : null,
    name: select ? select.name : "",
    description: select ? select.description : null,
    coefficient: select ? select.coefficient : "",
  });

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "close":
        {
          setSelect(null);
          setModal(false);
        }
        break;
      case "guardar":
        {
          //recreate form
          let formData = new FormData();
          formData.append("name", form.name);
          formData.append("description", form.description);
          formData.append("coefficient", form.coefficient);
          //formData.append("status", form.status);

          if (select) {
            //send api rest
            const response = await apiRest({
              url: "/Auth/metodosPago/" + select.id,
              type: "POST",
              form: formData,
              setLoading: setLoading,
            });

            if (response.status == 200 || response.status == 201) {
              let filter = {};
              fetch("/Auth/metodosPago", filter, setMetodosPago);
              return setModal(false);
            }
          }
        }
        break;
    }
  };

  const onChange = (e, value) => {
    switch (e.target.name) {
      case "coefficient":
      case "description":
      case "coefficient":
      case "name":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
    }
  };

  return (
    <div
      className="modal d-block effect-blur bg-dark bg-opacity-25 align-middle"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ zIndex: 104 }}
    >
      <div
        className="bg-light modal-dialog animation-modal my-md-5  overflow-hidden texto-normal"
        style={{ maxWidth: "600px", borderRadius: "20px" }}
      >
        <div className="modal-content bg-light">
          <div className="title m-0 bg-white p-4 d-flex justify-content-between">
            <div>
              <h1>Editar metodo de pago</h1>
              <span className="fs-6 text-muted"></span>
            </div>
            <div>
              <button
                className="border-0 bg-transparent "
                name="close"
                onFocus={(event) => onClick(event, null)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
          <div className="body p-3">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Nombre
                </label>
                <input
                  type="text"
                  className="form-control rounded-pill border-primary"
                  placeholder="Ingresa un nombre a tu metodo de pago"
                  name="name"
                  defaultValue={form.name}
                  onChange={(event) => onChange(event)}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Descripcion
                </label>
                <input
                  type="text"
                  className="form-control rounded-pill border-primary"
                  placeholder="Cambia la descripcion de tu metodo de pago"
                  name="description"
                  defaultValue={form.description}
                  onChange={(event) => onChange(event)}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label for="exampleFormControlInput1" className="form-label">
                  Coeficiente
                </label>
                <input
                  type="number"
                  className="form-control rounded-pill border-primary"
                  placeholder="0.00"
                  name="coefficient"
                  defaultValue={form.coefficient}
                  onChange={(event) => onChange(event)}
                />
              </div>

              <div className="col-md-12 mb-3 d-none">
                {" "}
                <label for="exampleFormControlInput1" className="form-label">
                  Estado
                </label>
                <select
                  className="form-select rounded-pill border-primary"
                  aria-label="Default select example"
                  name="status"
                  onChange={(event) => onChange(event)}
                >
                  {[
                    { option: "Activo", value: "activo" },
                    { option: "Inactivo", value: "inactivo" },
                  ].map((status) => {
                    if (status.value == select.status) {
                      return <option selected>{status.option}</option>;
                    }

                    if (status.value != select.status) {
                      return (
                        <option value={status.value}>{status.option}</option>
                      );
                    }
                  })}
                  <option value={"inactivo"}>Inactivo</option>
                </select>
              </div>
            </div>
          </div>
          <div className="footer bg-white p-4">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-primary rounded-pill me-2"
                name="guardar"
                onClick={(event) => onClick(event)}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalMetodoPago;
